export default "__VITE_ASSET__66fa4dfe__"